/* React base component */
import { Component } from "react"

/* Redux connect */
import { connect } from "react-redux"

/* Translation dictionary */
import translates from "../translates"

/* Component T */
class T extends Component {

    render = () => {
        /* Fields */
        const { lang, children } = this.props
        if (typeof children === "string" && `${lang}` in translates && `${children}` in translates[`${lang}`]) {
            return translates[`${lang}`][`${children}`]
        }
        return children
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        lang: state.lang
    }
}

/* Export */
export default connect(mapStateToProps)(T)
